import { type Route } from 'src/core/constants/routes';

export const routes: Record<string, Route> = {
  ROOT: {
    path: '/',
    analytics: {
      category: 'Auth',
      name: 'root',
    },
  },
  VERIFY_EMAIL: {
    path: '/auth/login/verify',
    analytics: {
      category: 'Auth',
      name: 'verify_email',
    },
  },
  LOGIN: {
    path: '/auth/login',
    analytics: {
      category: 'Auth',
      name: 'login',
    },
  },
  SAML: {
    path: '/auth/login/saml',
    analytics: {
      category: 'Auth',
      name: 'saml',
    },
  },
  FORGET: {
    path: '/auth/password/forget',
    analytics: {
      category: 'Auth',
      name: 'password_forget',
    },
  },
  RESET: {
    path: '/auth/password/reset/:token',
    analytics: {
      category: 'Auth',
      name: 'password_reset',
    },
  },
  SIGN_UP: {
    path: '/auth/invites',
    analytics: {
      category: 'Auth',
      name: 'invites',
    },
  },
  SIGN_UP_LINK: {
    path: '/auth/invites/link',
    analytics: {
      category: 'Auth',
      name: 'invites_link',
    },
  },
  SIGN_UP_JOIN_COMPANY: {
    path: '/auth/invites/join-company',
    analytics: {
      category: 'Auth',
      name: 'join_company',
    },
  },
  SIGN_UP_DECLINE: {
    path: '/auth/invites/decline',
    analytics: {
      category: 'Auth',
      name: 'invites_decline',
    },
  },
  LOGIN_SCA: {
    path: '/auth/login/sca',
    analytics: {
      category: 'Auth',
      name: 'login_sca',
    },
  },
  LOGIN_SCA_EMAIL_CONTINUATION: {
    path: '/auth/login/sca-email-continuation',
    analytics: {
      category: 'Auth',
      name: 'login_sca_email_continuation',
    },
  },
  LOGIN_FINALIZE_WITH_SCA: {
    path: '/auth/login/finalize-with-sca',
    analytics: {
      category: 'Auth',
      name: 'login_finalize_with_sca',
    },
  },
  PASSWORD_RESET_SCA: {
    path: '/auth/password-reset/sca',
    analytics: {
      category: 'Auth',
      name: 'password_reset_sca',
    },
  },
  FINALIZE_SCA: {
    path: '/auth/login/finalize/sca',
    analytics: {
      category: 'Auth',
      name: 'finalize_sca',
    },
  },
  FINALIZE_FAILED_SCA: {
    path: '/auth/login/finalize/sca-failed',
    analytics: {
      category: 'Auth',
      name: 'finalize_failed_sca',
    },
  },
  COMPANY_SELECT: {
    path: '/auth/login/select',
    analytics: {
      category: 'Auth',
      name: 'company_select',
    },
  },
  REGISTER: {
    path: '/auth/register',
    analytics: {
      category: 'Auth',
      name: 'register',
    },
  },
};
